module.exports = __webpack_public_path__ + "img/stress.ce8d943b.svg";